<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-4">
        <form @submit.prevent="handleSubmit" class="row g-3">
          <div class="p-field p-col-12 p-md-4">
            <span class="p-float-label">
              <InputText
                id="name"
                v-model="v$.name.$model"
                :class="{ 'p-invalid': v$.name.$invalid && submitted }"
              />
              <label
                for="name"
                :class="{ 'p-error': v$.name.$invalid && submitted }"
                >Name*</label
              >
            </span>
            <small
              v-if="
                (v$.name.$invalid && submitted) || v$.name.$pending.$response
              "
              class="p-error"
              >{{ v$.name.required.$message.replace('Value', 'Name') }}</small
            >
          </div>
          <div class="p-d-flex p-jc-center">
            <div class="p-mr-2"><Button type="submit" label="Guardar" /></div>
            <router-link to="/plantillas">
              <div class="p-mr-2"><Button type="button" label="Cancel" /></div>
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPut } from '../../helpers/rest-api';
import { required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      name: '',
      id: 0,
      style: '',
      submitted: false,
    };
  },
  validations() {
    return {
      name: {
        required,
      },
    };
  },

  mounted() {
    this.getId(this.$router.currentRoute.value.params.id);
  },

  methods: {
    getId(id) {
      apiGet(`plantilla/${id}`).then(
        (response) => (
          (this.name = response.data.name), (this.id = response.data.id), (this.style = response.data.style)
        )
      );
    },

    handleSubmit() {
      this.submitted = true;
      const { name, id, style } = this;
      apiPut(`plantilla/${id}`, JSON.stringify({name, style})).then(() =>
        this.$router.push('/plantillas')
      );
    },
  },
};
</script>
